import common from './common.json';
import error from './error.json';


const es = {
  common,
  error,
}

export default es;